<template>
  <div id="app">

    <Navside v-if="$route.name !=='Login'&& $route.name !=='ResetPassword' && $route.name !== 'ForgotPassword' && $route.name !== 'SMSTextingPolicy'"/>
    <router-view style="min-height: 100vh"/>
    <Footer v-if="$route.name !=='Login' && $route.name !== 'ResetPassword' && $route.name !== 'ForgotPassword' && $route.name !== 'SMSTextingPolicy'"/>
  </div>

</template>

<script>
  import Navside from "@/components/Navside.vue";
  import Footer from "@/components/Footer.vue";

  export default {
    components: {
      Navside,
      // eslint-disable-next-line
      Footer,
    }
  }
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');

$image-path: '~@/../mdb/mdbvue/img';
@import '~@/../mdb/mdbvue/scss/mdb-pro.scss';

#app 
{
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav 
{
  padding: 30px;

  a 
  {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active 
    {
      color: #42b983;
    }
  }
}

html,body
{
    overflow-x: hidden; 
}

.page-start 
{
  padding-top: 6em;
  background-color: #1b365d;
}

.sticky {
  position: fixed;
  top: 11vh;
  z-index: 9;
  background: #fff;
  box-shadow: 0 4px 2px -2px #888;
  margin: 0 0 50px;
}

.hideDiv {
  display: none;
}

.headerRow {
  padding: 0 5%;
  margin: 0;
}

.backBtn{
  position: absolute;
  top: 15px;
  left: 5%;
}
.floatingBtn{
  position: fixed;
  left: 15px;
  top: 15px;
  z-index: 999;
}
.closeDetailsBtn{
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.closeDetailsBtn:hover{
  color: rgb(156, 156, 156) !important;
}
.QuadrusButton, .QuadrusButton:hover 
{
	background-color: #407ec9 !important;
  color: white;
}

.viewBtnDefault{ 
  padding: 10px !important;
  border-radius: 4px;
}
.redBtn{
  background-color: #b54747 !important;
  color: white;
  padding: 10px !important;
  border-radius: 4px;
}

/* -TipTap Text Editor CSS- */
.ProseMirror 
{
	min-height: 350px;
}

.ProseMirror p.is-editor-empty:first-child::before 
{
  content: attr(data-placeholder);
  float: left;
  color: #ced4da;
  pointer-events: none;
  height: 20px;
}

.ProseMirror:focus 
{
	outline: none;
}
/* ------------------------ */

/* ----Form CSS Classes---- */
.invalidForm 
{
  box-shadow: 0 1px 0 red;
}

.validForm 
{
  box-shadow: 0 1px 0 green;
}

.disabledForm 
{
  background-color: rgb(228, 228, 228);

  .form-control:disabled, .form-control[readonly] 
  {
		background-color: rgb(228, 228, 228) !important;
  }
}

// loading spinner
.hideTable{
    display: none;
  }
  .hideSpinner{
    display: none;
  }
  .fadeIn {
    opacity: 1;
    animation-name: fadeInOpacity;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;
    animation-duration: 1s;
  }

  @keyframes fadeInOpacity {
    0% {
      opacity: 0;
    }
    25%{
      opacity: 0.25;
    }
    50%{
      opacity: .5;
    }
    75%{
      opacity: .75;
    }
    100% {
      opacity: 1;
    }
  }
input[type="file"] {
  border: none;
  padding: 0;
}
::file-selector-button {
  border: none;
  padding: 5px 10px;
  border-radius: 5px;
  background-color: #c4cacf;
}
::file-selector-button:hover {
  background-color: #e4e9ed;
  cursor: pointer;
}
/* ------------------------- */

</style>
